import { FormControl } from "@mui/material";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

export const BulkRecalculateOptionsContentStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-recalculate-options-content",
  },
)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const BulkRecalculateSwitchOptionStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-recalculate-switch-option",
  },
)`
  display: flex;
  flex-direction: column;

  .MuiFormControlLabel-root {
    margin: 0;
    align-items: flex-start;
  }

  .MuiFormHelperText-root {
    margin-top: 0;
    margin-inline-start: 52px;
    margin-bottom: 0;
  }
`;

export const BulkRecalculateAdvancedOptionsStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-recalculate-advanced-options",
  },
)`
  padding-inline-start: 8px;

  .MuiFormControlLabel-root {
    margin: 0;
    align-items: flex-start;
    column-gap: 10px;
  }
`;

export const BulkRecalculateAdvancedContentStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-recalculate-advanced-content",
  },
)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  background-color: ${greyMui._50};
  border-radius: 8px;
`;

export const BulkRecalculateSelectionPanelStyled = styled(
  FormControl,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "bulk-recalculate-selection-panel",
})`
  width: 100%;
  padding: 16px;
  background-color: ${greyMui._100};
  border-radius: 8px;

  .selection-radio-option {
    &:not(:last-child) {
      margin-bottom: 8px;
    }

    .MuiFormControlLabel-root {
      margin: 0;
      margin-inline-start: 4px;
      align-items: flex-start;
      column-gap: 10px;
    }

    .MuiFormControlLabel-label {
      margin-top: 2px;
    }
  }

  .selection-radio-label {
    display: flex;
    flex-direction: column;

    .radio-label {
      line-height: 1.4;
    }

    .MuiFormHelperText-root {
      margin: 0;
      line-height: 1.35;
    }
  }
`;
